import { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";
import { toast } from "react-toastify";
import LoadingSpinner from "../components/LoadingSpinner";
import "./Profile.css";

function Profile() {
  const [user, setUser] = useState(null);
  const [form, setForm] = useState({ name: "", password: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axiosClient
      .get("/user/profile")
      .then((res) => {
        setUser(res.data);
        setForm({ name: res.data.name, password: "" });
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const updateProfile = (e) => {
    e.preventDefault();
    setSaving(true);

    axiosClient
      .put("/user/profile", form)
      .then((res) => {
        toast.success("✅ Profile updated successfully");
        setUser(res.data.user);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        setForm({ ...form, password: "" });
      })
      .catch(() => toast.error("Failed to update profile"))
      .finally(() => setSaving(false));
  };

  if (loading) {
    return <LoadingSpinner message="Loading profile" sub="Fetching your account details…" />;
  }

  return (
    <div className="profile-page">
      <div className="profile-card">

        {/* Saving overlay */}
      {saving && <LoadingSpinner overlay message="Saving changes" sub="Updating your profile…" />}

      {/* Avatar */}
        <div className="profile-avatar-circle">
          {user?.name?.[0]?.toUpperCase() ?? "U"}
        </div>

        {/* Header */}
        <div className="profile-header">
          <h1 className="profile-title">{user?.name}</h1>
          <span className="profile-email-badge">✉ {user?.email}</span>
        </div>

        <div className="profile-divider" />

        {/* Form */}
        <form className="profile-form" onSubmit={updateProfile}>

          <div className="profile-field">
            <label className="profile-label">Full Name</label>
            <input
              className="profile-input"
              value={form.name}
              placeholder="Your name"
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </div>

          <div className="profile-field">
            <label className="profile-label">Email Address</label>
            <input
              className="profile-input"
              value={user.email}
              disabled
            />
          </div>

          <div className="profile-field">
            <label className="profile-label">New Password</label>
            <input
              className="profile-input"
              type="password"
              placeholder="Leave blank to keep current"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
            />
            <span className="profile-hint">Optional — only fill in if you want to change it</span>
          </div>

          <button
            type="submit"
            className={`profile-submit-btn ${saving ? "loading" : ""}`}
            disabled={saving}
          >
            {!saving && "Save Changes ✓"}
          </button>

        </form>
      </div>
    </div>
  );
}

export default Profile;
